import {Metric, PROCESS_NAME, APIEndpoint} from "../../common/constants";
import {getAPIGatewayRequest, getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import Moment from 'moment';
import { publishCount } from "../../../MetricUtility";

/**
 * This function will fetch driver reconciliation in batches
 * Why ? : Backend API has a restriction to fetch details of max 50 drivers in one go, hence we need to make multiple calls to get required data
 * @param params
 * @returns {Promise<{}>}
 */
export async function getDriverReconciliationInBatch(params) {
    const {stationCode, date} = params;
    let driverList = [];
    if (params.filters.driverName !== "") {
        let filteredDriver = params.driverList.find(driver =>
            driver.driverName === params.filters.driverName
        );
        driverList = [filteredDriver];
    } else {
        driverList = [...params.driverList];
    }

    let startTime = Moment(date).startOf('day').valueOf();
    let endTime = Moment(date).add(1, 'day').startOf('day').valueOf();
    console.group("Fetch driver reconciliation");
    console.log("Fetching driver reconciliation. Start Date %d - End Date %d", startTime, endTime);

    let apiResponse = {};
    let driverReconciliationList = [];
    let batchSize = 50;
    let batchNo = 0;
    let batchCallResult = [];
    while (driverList.length) {
        let slicedDriverList = driverList.splice(0, batchSize);
        let driverIdentifierList = transformDriverToDriverIdentifier(slicedDriverList);
        let requestParams = {
            stationCode: stationCode,
            dateRange: {
                startTime,
                endTime
            },
            driverIdentifiersList: driverIdentifierList
        };
        console.group("Driver reconciliation. Batch call : %d", (++batchNo));
        await getDriverReconciliation(requestParams).then(batchResponse => {
            batchCallResult.push(batchResponse.hasError);
            if (!batchResponse.hasError) {
                driverReconciliationList.push(...batchResponse.driverReconciliationList);
            }
            console.groupEnd();
        });
    }

    // If some calls fail
    if (batchCallResult.some(Boolean)) {
        apiResponse.hasError = true;
        apiResponse.errorMessage = batchCallResult.every(Boolean) ? "Failed to load driver reconciliation data" : "Loaded partial driver reconciliation data";
    }

    apiResponse.driverReconciliationList = driverReconciliationList;
    console.groupEnd();
    return apiResponse;
}

function transformDriverToDriverIdentifier(driverList) {
    let driverIdentifierList = [];
    driverList.forEach(driver => {
        let driverIdentifier = {compEmployeeId: driver.employeeId, tasId: driver.tasId, store: driver.store}
        driverIdentifierList.push(driverIdentifier);
    })
    return driverIdentifierList;
}

/**
 * this function will fetch driver reconciliation for provided driverInfo list
 * @param requestParams
 * @returns {Promise<{}>}
 */
async function getDriverReconciliation(requestParams) {
    let apiResponse = {};
    try {
        let apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.DRIVER_RECONCILIATION, requestParams, "POST");
        await getAPIGatewayDataFromParent(apiGatewayRequest).then(result => {
            if (result.status === 200) {
                apiResponse.driverReconciliationList = result.data.driverReconciliationList;
                apiResponse.hasError = false;
                publishCount(PROCESS_NAME, Metric.GetDriverReconciliation);
            } else {
                apiResponse.hasError = true;
                apiResponse.errorMessage = "Failed to fetch driver reconciliations";
                publishCount(PROCESS_NAME, Metric.GetDriverReconciliation_Failure);
                publishCount(PROCESS_NAME, Metric.GetDriverReconciliation);
            }
        });
    } catch (error) {
        apiResponse.hasError = true;
        publishCount(PROCESS_NAME, Metric.GetDriverReconciliation_Failure);
        publishCount(PROCESS_NAME, Metric.GetDriverReconciliation);
    }
    return apiResponse;
}

/**
 * this function will fetch list of drivers at provided station
 * @param stationCode
 * @returns {Promise<{}>}
 */
export async function getDrivers(stationCode) {
    let requestParams = {
        stationCode: stationCode,
        isActive: true
    }
    let apiResponse = {};
    try {
        let apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.GET_DRIVERS, requestParams, "POST");
        await getAPIGatewayDataFromParent(apiGatewayRequest).then(result => {
            if (result.status === 200) {
                apiResponse.driverList = result.data.driverList;
                apiResponse.hasError = false;
                publishCount(PROCESS_NAME, Metric.GetDrivers);
            } else {
                apiResponse.hasError = true;
                publishCount(PROCESS_NAME, Metric.GetDrivers_Failure);
                publishCount(PROCESS_NAME, Metric.GetDrivers);
            }
        });
    } catch (error) {
        apiResponse.hasError = true;
        publishCount(PROCESS_NAME, Metric.GetDrivers_Failure);
        publishCount(PROCESS_NAME, Metric.GetDrivers);
    }

    if (apiResponse.hasError) {
        apiResponse.errorMessage = "Failed to fetch driver list";
    }
    return apiResponse;
}



// WEBPACK FOOTER //
// ./src/component/driverReconciliation/network/driverReconciliationAPI.js